import React, { useState } from "react";
import MapChart from "../components/mapChart";
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/react-hooks';
import ReactTooltip from "react-tooltip";
import { CONDITIONALROUTES, SELECT_ROUTE } from "app/components/ConditionalEnums";

const GET_REGIONS = gql`
  query GetRegionsByUserGroup($group_id : Int!){
    getRegionsByUserGroup(group_id : $group_id ){
        name
        region_id
        exchange_rate
        currency_symbol
        icon
      }
      
  }
`;

const Currency = ({ setCurrency, calculator }) => {
  const [loading, setloading] = useState(false);
  const client = useApolloClient();
  const [dataShow, setDataShow] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  let [regionNames] = useState([]);
  const [content, setContent] = useState("");
  let group_id = (+sessionStorage.getItem('group_id'));

  const [search, setSearch] = useState("");


  React.useEffect(() => {
    console.log("mapsection", calculator);
    client.query({
      query: GET_REGIONS,
      variables: { group_id }
    }).then(res => {
      setDataShow(res.data);
      res.data.getRegionsByUserGroup.map((temp) => {
        if (temp.name === "Korea") {
          regionNames.push("South Korea");
          regionNames.push("North Korea");
        } else {
          regionNames.push(temp.name);
        }
        return temp.name;
      });
      setloading(true)
    }).catch(error => {
      // toast.error(error.graphQLErrors[0].messasge.message)
    });
  });
  var filteredCountries = dataShow?.getRegionsByUserGroup?.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  ) || [];

  return (
    <React.Fragment >
      {loading ?
        <div id="map-wrapper" className="d-flex justify-content-center flex-column mb-2">
          <p className="black-dark font-24 font-semi-bold mb-2">Please select your country of interest</p>
          <p className="mb-36">
            <span className="font-semi-bold">Note:</span> 
          Europe and North America use region-wide pricing (all countries have the same price), while APAC pricing varies by country.
          </p>
         
          <div className="d-flex justify-content-center  " style={{ columnGap: "124px"}}>
            <div className="">
            <MapChart setTooltipContent={setContent} regionNames={regionNames} setCurrency={setCurrency} data={dataShow} calculator={calculator} />
            <ReactTooltip >{content} </ReactTooltip>
            </div>
            <div className="d-flex justify-content-center ">
              <div
                className="country-container"
              >
                <p className="font-semi-bold font-14 mb-12">Choose Region</p>
                
                <div class="position-relative">
                  <input
                          type="text"
                          placeholder="Search"
                          className="form-control" // pe-5 adds right padding
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      <img src="/assets/FilterIcon.svg" alt="" class="position-absolute filer-icon" />
                  
        
                </div>
                <ul className="list-unstyled mt-12 ">
                  {filteredCountries.map((c) => (
                    <li
                    className="country-label-container"
                      key={c.region_id}
                      onClick={() => {
                        setCurrency(c.currency_symbol);
                        setSelectedCountry(c.name);
                        if (calculator === SELECT_ROUTE.COST) {
                          window.location.href = CONDITIONALROUTES.SELECTED_REGION_NAME_COST + c.name;
                        } else if (calculator === SELECT_ROUTE.CARBON) {
                          window.location.href = CONDITIONALROUTES.SELECTED_REGION_NAME_CARBON + c.name;
                        } else {
                          window.location.href = CONDITIONALROUTES.SELECTED_REGION_NAME_COST + c.name;
                        }
                      }}
                      
                    >
                      <img src={c.icon} alt="country icon"  width={40} height={28}/> 
                        
                      <span className="font-14 ">{c.name}</span>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
         
        </div>
        :
        // <div className="spinner-border text-secondary mt-n5"></div>
        <img className="mt-n5" src="./Spinner.svg" alt="loader" height="100px" />
      }
    </React.Fragment>
  )

}

export default Currency;